module.exports = __webpack_public_path__ + "img/Icon_Tc_Ts.b98bd298.png";